import { createFileRoute } from '@tanstack/react-router';
import { ClipPage } from '@/features/clips/clip-page';

export const Route = createFileRoute('/w/$workspaceId/clips/$clipId')({
  // `?t=` seeks to a time in seconds.
  validateSearch: (search: Record<string, unknown>): { t?: number } => {
    const t = Number(search.t);
    return Number.isFinite(t) && t >= 0 ? { t } : {};
  },
  component: ClipRoute,
});

function ClipRoute() {
  const { clipId } = Route.useParams();
  const { t } = Route.useSearch();
  return <ClipPage key={clipId} clipId={clipId} at={t} />;
}
